import '@patsnap-ui/icon/assets/solid/FolderMany.svg'
import { defineComponent, PropType, ref } from '@vue/composition-api'
import { Icon as PtIcon } from 'patsnap-biz'
import { BSavedSearchDialog } from '../../../BSavedSearchDialog/BSavedSearchDialog'
import cn from '../../locales/cn.json'
import en from '../../locales/en.json'
import $class from './BSaveSearchButton.module.scss'

export const BSaveSearchButton = defineComponent({
  name: 'BSaveSearchButton',
  i18n: {
    messages: { cn, en },
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    queryId: {
      type: String as PropType<string | undefined>,
    },
    queryText: {
      type: String,
    },
    filterText: {
      type: String,
    },
    showText: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
    },
    iconSize: {
      type: Number,
      default: 20,
    },
  },
  setup(props) {
    const dialogVisible = ref(false)
    function onShowDialog(e?: Event) {
      e?.stopPropagation()
      if (props.disabled || !props.queryId) return
      dialogVisible.value = true
    }

    return {
      dialogVisible,
      onShowDialog,
    }
  },
  render() {
    const disabled = this.disabled || !this.queryId
    const buttonText = this.buttonText || this.$tc('commonList.saveSearch')

    return (
      <div class={$class.container}>
        <div
          class={[$class.button, disabled ? $class.disabled : '']}
          title={buttonText}
          aria-label={buttonText}
          onClick={this.onShowDialog}
          data-testid="b-save-search-button"
        >
          <PtIcon
            icon="SolidFolderMany"
            class={disabled ? 'text-gray-55' : 'text-gray-450'}
            style={{
              width: `${this.iconSize}px`,
              height: `${this.iconSize}px`,
            }}
          ></PtIcon>
          {this.showText ? <span class={[$class.title, disabled ? 'text-gray-55' : 'text-text-default']}>{buttonText}</span> : null}
        </div>
        <BSavedSearchDialog
          visible={this.dialogVisible}
          queryId={this.queryId}
          queryText={this.queryText}
          filterText={this.filterText}
          onInput={(visible: boolean) => {
            this.dialogVisible = visible
          }}
        ></BSavedSearchDialog>
      </div>
    )
  },
})
